import { bannerStyling } from "@made-people/blueprint-banner/blueprint";

bannerStyling.override({
  slots: {
    base: "relative flex bg-black/20 text-white group/banner rounded-lg @[97vw]:rounded-none overflow-hidden",
    contentWrapper:
      "flex flex-col z-10 w-full pointer-events-none max-w-component-max-w-xl box-content mx-auto p-4 md:px-6 md:py-8 lg:px-10 lg:py-14 xl:px-20 xl:py-32 group-data-[has-spacing=false]/banner:group-data-[in-grid=false]/banner:p-8 group-data-[has-spacing=false]/banner:group-data-[in-grid=false]/banner:md:p-14 group-data-[has-spacing=false]/banner:group-data-[in-grid=false]/banner:lg:p-16 group-data-[in-swiper=true]/banner:p-6",
    ctasWrapper: "flex flex-wrap gap-2 mt-4 lg:mt-8 z-30 pointer-events-auto",
    tagsWrapper: "flex gap-2 lg:gap-4 mb-4 md:mb-4 lg:mb-6 flex-wrap",
    tag: "text-label-md lg:text-sm uppercase px-2.5 py-1.5 rounded-md text-nowrap",
    headingWrapper: "",
    link: "absolute w-full h-full left-0 top-0 z-20",
    contentShadow: "from-black/40 to-[100%]",
    background:
      "w-full h-full absolute left-0 top-0 object-cover data-[is-video]:z-10",
  },
  variants: {
    stickyContent: {
      true: {
        base: "overflow-[unset]",
        contentWrapper: "sticky bottom-0 left-0 right-0 z-30",
      },
    },
    colorTheme: {
      white: {
        base: "text-white",
      },
      black: {
        base: "text-black",
      },
    },
    contentPosition: {
      "top-left": {
        base: "justify-start items-start",
        contentWrapper: "justify-start items-start text-left",
        contentShadow: "bg-radial-[at_top_left]",
      },
      "top-center": {
        base: "justify-center items-start",
        contentWrapper: "justify-center items-center text-center",
        contentShadow: "bg-radial-[at_top_center]",
      },
      "top-right": {
        base: "justify-end items-start",
        contentWrapper: "justify-end items-end text-right",
        contentShadow: "bg-radial-[at_top_right]",
      },
      "center-left": {
        base: "justify-start items-center",
        contentWrapper: "justify-start items-start text-left",
        contentShadow: "bg-radial-[at_center_left]",
      },
      "center-center": {
        base: "justify-center items-center",
        contentWrapper: "justify-center items-center text-center",
        contentShadow: "bg-radial-[at_center_center]",
      },
      "center-right": {
        base: "justify-end items-center",
        contentWrapper: "justify-end items-end text-right",
        contentShadow: "bg-radial-[at_center_right]",
      },
      "bottom-left": {
        base: "justify-start items-end",
        contentWrapper: "justify-start items-start text-left",
        contentShadow: "bg-radial-[at_bottom_left]",
      },
      "bottom-center": {
        base: "justify-center items-end",
        contentWrapper: "justify-center items-center text-center",
        contentShadow: "bg-radial-[at_bottom_center]",
      },
      "bottom-right": {
        base: "justify-end items-end",
        contentWrapper: "justify-end items-end text-right",
        contentShadow: "bg-radial-[at_bottom_right]",
      },
    },
    dim: {
      none: {
        base: "brightness-100",
      },
      subtle: {
        background: "brightness-95",
      },
      medium: {
        background: "brightness-90",
      },
      strong: {
        background: "brightness-75",
      },
    },
    size: {
      portrait: {
        base: "aspect-portrait",
      },
      tall: {
        base: "aspect-tall",
      },
      square: {
        base: "aspect-square",
      },
      landscape: {
        base: "aspect-landscape",
      },
      wide: {
        base: "aspect-wide",
      },
      "ultra-wide": {
        base: "aspect-ultra-wide",
      },
      panorama: {
        base: "aspect-panorama",
      },
      auto: {
        base: "aspect-[var(--aspect-ratio-mobile)] md:aspect-[var(--aspect-ratio-tablet)] lg:aspect-[var(--aspect-ratio-desktop)]",
      },
    },
    tagColor: {
      white: {
        tag: "bg-white/70 text-black",
      },
      black: {
        tag: "bg-black/70 text-white",
      },
    },
  },
  defaultVariants: {
    size: { initial: "portrait", lg: "wide" },
    contentPosition: "bottom-left",
    dim: "none",
    tagColor: "black",
    stickyContent: "true",
  },
});
